import React, { useState } from 'react';

export default ({ title, classes, isInheritedConcept, children }) => {
  const [isOpened, setOpened] = useState(isInheritedConcept);

  const toggleAccordeon = () => {
    setOpened(!isOpened);
  };

  return (
    <div className={classes.mb20}>
      <div
        className={`${classes.conceptAccHead} ${isOpened ? classes.active : ''}`}
        style={{
          fontStyle: `${isInheritedConcept ? '' : 'italic'}`,
          background: `${isInheritedConcept ? '#222029' : 'rgba(103, 94, 120, 0.7)'}`,
        }}
        onClick={toggleAccordeon}
      >
        {title}
      </div>

      {isOpened ? <div className={classes.conceptAccContent}>{children}</div> : null}
    </div>
  );
};
